import { render, staticRenderFns } from "./ListStock.vue?vue&type=template&id=5a40c2bd&"
import script from "./ListStock.vue?vue&type=script&lang=js&"
export * from "./ListStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Ramon/PROYECTOS/JuanGabriel_POS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a40c2bd')) {
      api.createRecord('5a40c2bd', component.options)
    } else {
      api.reload('5a40c2bd', component.options)
    }
    module.hot.accept("./ListStock.vue?vue&type=template&id=5a40c2bd&", function () {
      api.rerender('5a40c2bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/ListStock.vue"
export default component.exports